module.exports = __webpack_public_path__ + "static/carbon-table-toolbar-02b5d2e949e67932c74f6ef0b553d632.png";